<template>
  <a-scene
    main-scene
    xrextras-almost-there
    xrextras-loading
    xrextras-runtime-error
    cursor="fuse: false; rayOrigin: mouse"
    raycaster="objects: .clickable"
    renderer="color-management:true; physically-correct-lights:true;"
    xrweb
  >
    <!-- coaching-overlay="animationColor: #E86FFF;
    promptText: Please push your phone forward and then pull back;"git
    xrextras-gesture-detector
    xrweb="scale: absolute;" -->

    <!-- capture button — only in AR experience, not creation form -->
    <xrextras-capture-button capture-mode="standard" />

    <!-- configure capture settings -->
    <xrextras-capture-config
      :watermark-image-url="photoframe !== '' ? photoframe : dropsIcon.png"
      watermark-max-width="100"
      watermark-max-height="100"
      max-dimension="1920"
      file-name-prefix="drops-image-"
      watermark-location="topLeft"
    />

    <!-- Assets to load when A-Frame initializes
    slows down load time -->
    <a-assets>
      <video id="video-asset" crossorigin="anonymous" src="" loop="true" />
    </a-assets>

    <audio id="audio" src="" loop crossorigin response-type="arraybuffer" />
    <video src="" autoplay crossorigin playsinline />

    <!-- add capture preview -->
    <xrextras-capture-preview />

    <!-- camera -->
    <a-camera id="camera" camera position="0 9 0" />

    <DropScene id="dropscene" visible="false" />
    <OpeningScene id="opening" visible="true" />

    <!-- lighting -->
    <a-entity
      light="type: directional; color: #ffffff; intensity: 1; castShadow: true"
      position="1, 1.75, 1"
    />
    <a-entity
      light="type: directional; color: #ffffff; intensity: 1.5; castShadow: true"
      position="0, 1, 1"
    />
    <a-entity
      light="type: directional; color: #ffffff; intensity: 2; castShadow: true"
      position="-1, .5, -2"
    />

    <a-light xr-light light="type: ambient; color: #333" />
  </a-scene>
</template>

<script>
import { mapState } from 'vuex'

import AFrameComponents from '../mixins/aframe/Main'
import OpeningScene from '~/components/scenes/Opening'
import DropScene from '~/components/scenes/Drop'

export default {
  components: { OpeningScene, DropScene },
  mixins: [AFrameComponents],
  computed: {
    ...mapState(['drop', 'photoframe'])
  },
  mounted () {
    this.aframeComponents()
    if (!this.drop.showWrapper) {
      document.querySelector('#dropscene').setAttribute('visible', true)
      document.querySelector('#opening').setAttribute('visible', false)
    }
  },
  methods: {}
}
</script>

<style scoped>
a-scene {
  height: 100vh;
}
</style>
